<template>
  <div>
    <div v-if="!loading">
      <v-speed-dial v-model="fab" center direction="left" open-on-hover>
        <template v-slot:activator>
          <v-btn v-model="fab" color="teal" small dark fab>
            <v-icon v-if="fab">mdi-close</v-icon>
            <v-icon v-else>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-tooltip bottom v-if="create">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="indigo" v-on="on" @click="doCreate()" class="tableActionBtn">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>{{createText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="review">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="green" v-on="on" @click="doReview()" class="tableActionBtn">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>{{reviewText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="query">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="cyan" v-on="on" @click="doQuery()" class="tableActionBtn">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </template>
          <span>{{queryText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="copy">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="cyan" v-on="on" @click="doCopy()" class="tableActionBtn">
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span>{{copyText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="amend">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="cyan" v-on="on" @click="doAmend()" class="tableActionBtn">
              <v-icon>mdi-gesture-tap</v-icon>
            </v-btn>
          </template>
          <span>{{amendText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="pay">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="cyan" v-on="on" @click="doPay()" class="tableActionBtn">
              <v-icon>mdi-cash</v-icon>
            </v-btn>
          </template>
          <span>{{amendText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="custom">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="cyan" v-on="on" @click="doCustom()" class="tableActionBtn">
              <v-icon>{{ `${customIcon}` }}</v-icon>
            </v-btn>
          </template>
          <span>{{customText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="remove">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="red" v-on="on" @click="doRemove()" class="tableActionBtn">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>{{removeText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="undo">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="cyan" v-on="on" @click="doUndo()" class="tableActionBtn">
              <v-icon>mdi-undo</v-icon>
            </v-btn>
          </template>
          <span>{{undoText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="reopen">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="green" v-on="on" @click="doReopen()" class="tableActionBtn">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>{{reopenText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="download">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="blue" v-on="on" @click="doDownload()" class="tableActionBtn">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <span>{{downloadText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="unread">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="blue" v-on="on" @click="doUnread()" class="tableActionBtn">
              <v-icon>mdi-email</v-icon>
            </v-btn>
          </template>
          <span>{{unreadText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="read">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="green" v-on="on" @click="doRead()" class="tableActionBtn">
              <v-icon>mdi-email-open</v-icon>
            </v-btn>
          </template>
          <span>{{readText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="endorse">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="green" v-on="on" @click="doEndorse()" class="tableActionBtn">
              <v-icon>mdi-email-open</v-icon>
            </v-btn>
          </template>
          <span>{{endorseText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="inprogress">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="blue" v-on="on" @click="doInprogress()" class="tableActionBtn">
              <v-icon>mdi-history</v-icon>
            </v-btn>
          </template>
          <span>{{inprogressText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="error">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="red" v-on="on" @click="doError()" class="tableActionBtn">
              <v-icon>mdi-alert</v-icon>
            </v-btn>
          </template>
          <span>{{errorText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="batch_error">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="red" v-on="on" @click="doBatchError()" class="tableActionBtn">
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
          <span>{{batchErrorText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="cancel">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="red" v-on="on" @click="doCancel()" class="tableActionBtn">
              <v-icon>mdi-cancel</v-icon>
            </v-btn>
          </template>
          <span>{{cancelText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="terminate">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="red" v-on="on" @click="doTerminate()" class="tableActionBtn">
              <v-icon>mdi-close-octagon</v-icon>
            </v-btn>
          </template>
          <span>{{terminateText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="retry">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="blue" v-on="on" @click="doRetry()" class="tableActionBtn">
              <v-icon>mdi-reload</v-icon>
            </v-btn>
          </template>
          <span>{{retryText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="unscheduled">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="red" v-on="on" @click="doUnscheduled()" class="tableActionBtn">
              <v-icon>mdi-timer-off</v-icon>
            </v-btn>
          </template>
          <span>{{unscheduledText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="batch_param">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="cyan" v-on="on" @click="doBatchParam()" class="tableActionBtn">
              <v-icon>mdi-note-text</v-icon>
            </v-btn>
          </template>
          <span>{{batchParamText}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="report_param">
          <template v-slot:activator="{ on }">
            <v-btn fab dark small color="cyan" v-on="on" @click="doReportParam()" class="tableActionBtn">
              <v-icon>mdi-note-text</v-icon>
            </v-btn>
          </template>
          <span>{{reportParamText}}</span>
        </v-tooltip>
      </v-speed-dial>
    </div>
    <div v-else>
      <v-progress-circular indeterminate color="primary" :size="20" :width="2"></v-progress-circular>
    </div>
  </div>
</template>

<script>
// Commonly used action
export default {
  data() {
    return {
      fab: false
    }
  },
  methods: {
    doQuery() {
      this.$emit('query', this.rowData)
    },
    doReview() {
      this.$emit('review', this.rowData)
    },
    doRemove() {
      this.$emit('remove', this.rowData)
    },
    doCreate() {
      this.$emit('create', this.rowData)
    },
    doCopy() {
      this.$emit('copy', this.rowData)
    },
    doAmend() {
      this.$emit('amend', this.rowData)
    },
    doPay() {
      this.$emit('pay', this.rowData)
    },
    doCustom() {
      this.$emit('custom', this.rowData)
    },
    doUndo() {
      this.$emit('undo', this.rowData)
    },
    doReopen() {
      this.$emit('reopen', this.rowData)
    },
    doRedownload() {
      this.$emit('redownload', this.rowData)
    },
    doDownload() {
      this.$emit('download', this.rowData)
    },
    doUnread() {
      this.$emit('unread', this.rowData)
    },
    doRead() {
      this.$emit('read', this.rowData)
    },
    doEndorse() {
      this.$emit('endorse', this.rowData)
    },
    doInprogress() {
      this.$emit('inprogress', this.rowData)
    },
    doError() {
      this.$emit('error', this.rowData)
    },
    doBatchError() {
      this.$emit('batch_error', this.rowData)
    },
    doBatchParam() {
      this.$emit('batch_param', this.rowData)
    },
    doReportParam() {
      this.$emit('report_param', this.rowData)
    },
    doCancel() {
      this.$emit('cancel', this.rowData)
    },
    doTerminate() {
      this.$emit('terminate', this.rowData)
    },
    doRetry() {
      this.$emit('retry', this.rowData)
    },
    doUnscheduled() {
      this.$emit('unscheduled', this.rowData)
    }
  },
  props: {
    rowData: {
      type: Object,
      default: () => { }
    },
    query: {
      type: Boolean,
      default: false
    },
    review: {
      type: Boolean,
      default: false
    },
    remove: {
      type: Boolean,
      default: false
    },
    create: {
      type: Boolean,
      default: false
    },
    copy: {
      type: Boolean,
      default: false
    },
    amend: {
      type: Boolean,
      default: false
    },
    pay: {
      type: Boolean,
      default: false
    },
    undo: {
      type: Boolean,
      default: false
    },
    reopen: {
      type: Boolean,
      default: false
    },
    redownload: {
      type: Boolean,
      default: false
    },
    download: {
      type: Boolean,
      default: false
    },
    unread: {
      type: Boolean,
      default: false
    },
    read: {
      type: Boolean,
      default: false
    },
    endorse: {
      type: Boolean,
      default: false
    },
    inprogress: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    batch_error: {
      type: Boolean,
      default: false
    },
    batch_param: {
      type: Boolean,
      default: false
    },
    report_param: {
      type: Boolean,
      default: false
    },
    cancel: {
      type: Boolean,
      default: false
    },
    terminate: {
      type: Boolean,
      default: false
    },
    unscheduled: {
      type: Boolean,
      default: false
    },
    retry: {
      type: Boolean,
      default: false
    },
    queryText: {
      type: String,
      default: 'Query'
    },
    reviewText: {
      type: String,
      default: 'Review'
    },
    removeText: {
      type: String,
      default: 'Remove'
    },
    copyText: {
      type: String,
      default: 'Copy'
    },
    amendText: {
      type: String,
      default: 'Select'
    },
    custom: {
      type: Boolean,
      default: false
    },
    customIcon: {
      type: String,
      default: ''
    },
    customText: {
      type: String,
      default: 'Custom'
    },
    loading: {
      type: Boolean,
      default: false
    },
    createText: {
      type: String,
      default: 'Create'
    },
    payText: {
      type: String,
      default: 'Pay'
    },
    undoText: {
      type: String,
      default: 'Undo'
    },
    reopenText: {
      type: String,
      default: 'Reopen'
    },
    downloadText: {
      type: String,
      default: 'Download'
    },
    unreadText: {
      type: String,
      default: 'Unread'
    },
    readText: {
      type: String,
      default: 'Read'
    },
    endorseText: {
      type: String,
      default: 'Endorse'
    },
    inprogressText: {
      type: String,
      default: 'In-progress'
    },
    errorText: {
      type: String,
      default: 'Error'
    },
    batchErrorText: {
      type: String,
      default: 'Show error logs'
    },
    batchParamText: {
      type: String,
      default: 'Show Parameters'
    },
    reportParamText: {
      type: String,
      default: 'Show Parameters'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    terminateText: {
      type: String,
      default: 'Terminate'
    },
    retryText: {
      type: String,
      default: 'Retry'
    },
    unscheduledText: {
      type: String,
      default: 'Unscheduled'
    }
  }
}
</script>

<style lang="scss">
.tableActionBtn {
  margin: 2px;
}
</style>
